<div class="seg" role="tablist">
  <ng-container *ngFor="let option of options; let last = last">
    <button
      type="button"
      role="tab"
      [class.on]="option.value === value"
      [attr.aria-selected]="option.value === value"
      (click)="onSelect(option)"
    >
      {{ option.label }}
    </button>
    <i *ngIf="!last"></i>
  </ng-container>
</div>
